type IconProps = React.SVGProps<SVGSVGElement>;

const UserDemo: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2133 14.4933C12.08 14.48 11.92 14.48 11.7733 14.4933C8.59999 14.3867 6.07999 11.7867 6.07999 8.58667C6.07999 5.32001 8.71999 2.66667 12 2.66667C15.2667 2.66667 17.92 5.32001 17.92 8.58667C17.9067 11.7867 15.3867 14.3867 12.2133 14.4933Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.88 5.33333C24.4667 5.33333 26.5467 7.42666 26.5467 10C26.5467 12.52 24.5467 14.5733 22.0533 14.6667C21.9467 14.6533 21.8267 14.6533 21.7067 14.6667"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.54668 19.4133C2.32001 21.5733 2.32001 25.0933 5.54668 27.24C9.21335 29.6933 15.2267 29.6933 18.8933 27.24C22.12 25.08 22.12 21.56 18.8933 19.4133C15.24 16.9733 9.22668 16.9733 5.54668 19.4133Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.4533 26.6667C25.4133 26.4667 26.32 26.08 27.0667 25.5067C29.1467 23.9467 29.1467 21.3733 27.0667 19.8133C26.3333 19.2533 25.44 18.88 24.4933 18.6667"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UserDemo;
